
import { connect } from 'react-redux'
import { configureItemRenderer } from './helpers'
import './index.scss'

Attributes = ({ data, height }) ->

  Details = configureItemRenderer(data.type, data.entityType, data.viewType)

  <div style={{
    flex: '1 1 auto',
    overflow: 'auto',
    maxHeight: (height - 225)
  }}>
    <Details data={data} />
  </div>

export default connect(
  ({ explore }) -> {
    data: explore.currentItem
    height: explore.height
  }
)(Attributes)
